<template>
    <router-link :to="{name: 'single', params: {language: language, slug: item.slug}}"
                 class='calendar-item swiper-slide'>

        <div class='large-numeral secondary-color light'>{{item.date}}</div>

        <div v-if='language === "nl"'
             class='date small-text secondary-color bold'>
            <span>{{item.nl.day}}</span>
            <span>{{item.nl.month}}</span>
        </div>

        <div v-if='language === "en"'
             class='date small-text secondary-color bold'>
            <span>{{item.en.day}}</span>
            <span>{{item.en.month}}</span>
        </div>

        <div v-if='language === "nl"'
             class='calendar-description small-text secondary-color'
             v-html='item.title'></div>
        <div v-if='language === "en"'
             class='calendar-description small-text secondary-color'
             v-html='item.title_en'></div>

    </router-link>
</template>

<script>
export default {
  name: 'dsCalendarItem',
  props: ['language', 'item']
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';

.calendar-item {
  display: block;
  height: 14 * $baseline;
}

.date {
  height: 4 * $baseline;
  span {
    display: block;
    height: $baseline;
    margin-bottom: $baseline;
    top: $correction;
    position: relative;
  }
  padding-bottom: $baseline;
}

.large-numeral {
  position: relative;
  left: -2px;
  float: left;
  margin-top: $baseline;
  height: 3 * $baseline;
  width: 1.5 * $margin;
  font-size: $large-numeral;
}

.calendar-description {
  height: 4 * $baseline;
  line-height: 2 * $baseline;
  span {
    top: -5px;
    position: relative;
  }
}

a {
  border: none;
  &:active,
  &:hover {
    color: $main-color !important;
  }
}
</style>



// WEBPACK FOOTER //
// dsCalendarItem.vue?5dc9d0c8